export const LIMIT = 25;

export interface NewsFeedArticle {
  approved_at: string;
  author: string;
  created_at: string;
  image_url?: string;
  link: string;
  published_at: string;
  ref_id: string;
  title: string;
  num_likes?: number;
  num_views: number;
  source: string;
  usr_liked?: boolean;
  usr_viewed?: boolean;
}

export enum ActivityAction {
  VIEWED = "viewed",
  LIKED = "liked",
  UNLIKED = "unliked",
}
